import { ol_Feature } from "@omnia/exports/openlayers";
import { FieldViewModel } from "../fields";
import { CroppingLayer } from "../fields/map/layers/croppingLayer";
import { CroppingLayerStyle } from "../fields/map/layers/croppingStyle";

export class CroppingStyle extends CroppingLayerStyle {
    private _colors: { [key: number]: number[] };

    constructor(layer: CroppingLayer) {
        super(layer);
    }

    public refresh(colors: { [key: number]: number[] }) {
        this._colors = colors;
        this.layer.refresh();
    }

    protected getCroppingColor(feature: ol_Feature, selected: boolean, opacity: number) {
        if (this._colors) {
            const data = <FieldViewModel>feature.get("data");

            if (data) {
                return this._colors[data.fieldId] || [255, 255, 255, 0.1];
            }
        }

        return super.getCroppingColor(feature, selected, opacity);
    }
}
